// extracted by mini-css-extract-plugin
export var text = "_17-0";